import { DatePickerProps, InputProps, RadioProps, SelectProps } from '@trackman/web-shared-components';

type FilterTypeBase = {
  id: string;
  columnNumber: number;
  onSave: () => void;
};

export type StringDate = string | null;
export type DatePeriod = { startDate: StringDate; endDate: StringDate };

export enum Filter {
  Select = 'select',
  Radio = 'radio',
  Date = 'date',
  DateRange = 'date_range',
  Textfields = 'textfields',
}

export type FilterType = FilterTypeBase &
  (
    | {
        type: Filter.Select;
        chipDescription: string;
        selectProps: SelectProps;
      }
    | {
        type: Filter.Radio;
        chipDescription: string;
        radioProps: RadioProps[];
      }
    | {
        type: Filter.Date;
        chipDescription: string;
        datePickerProps: DatePickerProps;
      }
    | {
        type: Filter.DateRange;
        chipDescription: string;
        startDateProps: DatePickerProps;
        endDateProps: DatePickerProps;
      }
    | {
        type: Filter.Textfields;
        chipDescription: string[];
        inputProps: InputProps[];
      }
  );

export default FilterType;
